import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ShieldCheck, ArrowRight, Wallet } from "lucide-react";
import { getTransparency } from "@/lib/api";

export default function TransparencyTeaser() {
  const [data, setData] = useState(null);

  useEffect(() => {
    getTransparency().then(setData).catch(() => {});
  }, []);

  return (
    <section className="py-20 px-6 md:px-12 max-w-7xl mx-auto" data-testid="transparency-teaser">
      <motion.a
        href="/transparency"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        data-testid="transparency-teaser-link"
        className="group relative block border border-white/10 bg-card/60 p-8 sm:p-12 overflow-hidden hover:border-ember/60 transition-colors"
      >
        <div className="absolute -top-24 -right-24 w-72 h-72 bg-ember/10 blur-3xl rounded-full pointer-events-none group-hover:bg-ember/20 transition-colors" />
        <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-ember">
              <ShieldCheck className="w-4 h-4" /> Impact &amp; Transparency
            </span>
            <h2 className="mt-4 text-3xl sm:text-4xl font-display font-bold tracking-tight">
              Watch our charity wallet <span className="text-ember">live on-chain.</span>
            </h2>
            <p className="mt-4 text-sm md:text-base text-muted-foreground leading-relaxed">
              No promises — proof. Track the charity wallet balance on Base in real time, and see every
              donation logged with an on-chain transaction and an official receipt.
            </p>
            <span className="mt-6 inline-flex items-center gap-2 font-mono text-sm text-ember group-hover:gap-3 transition-all">
              See the transparency ledger <ArrowRight className="w-4 h-4" />
            </span>
          </div>

          <div className="shrink-0 border border-white/10 bg-background p-6 min-w-[220px]">
            <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
              <Wallet className="w-4 h-4 text-ember" /> Charity Wallet · Base
            </div>
            <div className="mt-4 text-3xl font-display font-bold text-ember font-mono">
              {data?.balance_eth != null ? `${data.balance_eth} ETH` : "— ETH"}
            </div>
            <div className="mt-1 text-xs text-muted-foreground">
              {data?.balance_usd != null ? `≈ $${data.balance_usd.toLocaleString()} USD` : "Live from Base"}
            </div>
            <div className="mt-4 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-wider text-emerald-400 border border-emerald-500/30 bg-emerald-500/5 px-2 py-1">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" /> Live on-chain
            </div>
          </div>
        </div>
      </motion.a>
    </section>
  );
}
